import axios from "axios";

const get = ({ id }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/campaign/api/admin/lucky-draw-participants/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const getParticipantDetail = {
  get
};

export default getParticipantDetail;
